/* eslint-disable */
import { getToken, setToken, removeCookie, setCookie, getCookie } from './auth' // get token from cookie
import axios from 'axios' // 引用axios
import { MessageBox, Message } from 'element-ui'
import router from '../router/index'
import store from '../../src/store/index'

// axios 配置
// axios.defaults.timeout = 15000 //设置接口响应时间

axios.defaults.baseURL = '' // 这是调用数据接口,公共接口url+调用接口名

// let httpUrl = window.location.host
//
// if (httpUrl.indexOf('.com') !== -1) {
//     console.log('生产环境', httpUrl)
// } else if (httpUrl.indexOf('.net') !== -1) {
//     console.log('测试环境', httpUrl)
//     axios.defaults.baseURL = 'http://www.test.com' // 这是调用数据接口,公共接口url+调用接口名
// } else if (httpUrl.indexOf('localhost:8088') !== -1) {
//     console.log('指定开发环境', httpUrl)
//     axios.defaults.baseURL = 'http://localhost:8088/'
// } else {
//     console.log('开发环境', httpUrl)
//     axios.defaults.baseURL = 'http://192.168.6.138:8080/' // 这是调用数据接口,公共接口url+调用接口名
// }

// http request 拦截器，通过这个，我们就可以把Cookie传到后台

/**处理用户登录超时**/
// 重复操作
// axios.interceptors.request.use(config => config, error => Promise.reject(error));
// axios.interceptors.response.use((response) => {
//     const status = response.data.code;
//     if (status === 70002) {
//         removeCookie('uToken');
//         // if (sessionStorage.getItem('isNaigation') === 'yes') {
//         //   window.parent.location.href = '/';
//         // } else {
//         //   window.location.href = '/';
//         // }
//         window.location.href = '/';
//     } else return response;
// }, error => Promise.reject(error));
axios.interceptors.request.use(
  config => {
    // config.timeout = config.time || 360000
    config.timeout = 360000
    let token = getToken() // sessionStorage.getItem('uToken')
    if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = ' Bearer ' + token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      const { code } = response.data
      /**
       * response.data.code
       * 200     成功处理请求
       * ==============================
       * 70000   登录成功登录成功进行跳转
       * 70001   重复登录同一个账号只能一个客户端登录
       * 70002   登录超时需要再次登录
       * 70003   用户名或密码不对需要重新提交
       * 70004   账户异常,用户已冻结请联系系统管理员进行解冻操作
       * ==============================
       * 70020   无权限访问越权访问，
       * 70021   操作失败!
       * ==============================
       * 999   系统异常,请联系管理员请求处理异常，可二次尝试
       */
      if(response.data.code === 70020 && response.data.msg === '权限不足,如有疑问请联系系统管理员!'){
        Message({
          message: '权限不足,如有疑问请联系系统管理员!',
          type: 'error'
        })
        return Promise.reject('权限不足,如有疑问请联系系统管理员!')
      }
      if (response.data.code === 70000) {
        if (response.config.url.indexOf('auth') > -1) {
          //这是处理登录请求
          /**
           * 保存Token to localStorage or cookie
           */
          //sessionStorage.setItem('uToken', response.data.obj);
          setToken(response.data.obj.token)
          setCookie('login_UserName', response.data.obj.usercnname)
          /**
           * 如果有来路则返回来路否则进行首页跳转
           */
          //判断是否有 currentUrl
          // router.push({ path: '/' });
        } else {
          //console.log(response)
        }

      } else if (code === 70002) {
        Throttle(()=>{
          Message({
            message: '用户信息已过期请重新登陆',
            type: 'error'
          })
        },2000)
        removeCookie('uToken')
        localStorage.clear()
        router.push({ path: '/' })
      } else if (response.data.code === 999) {

        MessageBox.confirm(response.data.msg, '系统异常', {
          confirmButtonText: '关闭',
          //cancelButtonText: '取消',
          type: 'warning',
          message: response.data.message
        }).then(() => {
          /**接收用户上报信息**/

        })

      } else if (response.data.code === 90001) {
        MessageBox.confirm(response.data.msg, '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          router.push({ path: '/login' })
        })

      } else if (response.data.code === 70071) {
        this.$message('验证码有误,请重新输入')
      } else {
        //其他错误!!
      }
    }

    return response
  },
  error => {
    store.state.isFalse = true
    if (error.toString().trim() ===
      'TypeError: Cannot read property \'cancelToken\' of null'
    ) {
      sessionStorage.removeItem('userInfo')
      MessageBox.confirm(
        '会话凭证失效，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        //  console.log('此处应退出登录  重新实例化')
        router.push({ path: '/login' })
      })
    }

    // console.log(error.toString().trim())
    if (error.toString().trim() === 'Error: Network Error') {
      MessageBox.alert('网络请求异常，请稍后重试', '出错了', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    }
    return Promise.reject(error.response)
  }
)
export default axios



/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then(response => {
        //判断用户是否登录超时
        resolve(response.data)
      })
      .catch(err => {
        if (err.status === 500) {
          MessageBox.alert('网络请求异常!', '出错了', {
            confirmButtonText: '确定',
            callback: action => {
              removeCookie('uToken')
              removeCookie('login_UserName')
              removeCookie('currentUrl')
              this.$router.push({ path: '/login' })

            }
          })
        }
      })
  })
}


const Throttle = (fn, t) => {
  let last;
  let timer;
  let interval = t || 500;
  return function () {
    let args = arguments;
    let now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  }
};

//
/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        if (err.status === 500) {
          MessageBox.alert('网络请求异常!', '出错了', {
            confirmButtonText: '确定',
            callback: action => {
              removeCookie('uToken')
              removeCookie('login_UserName')
              removeCookie('currentUrl')
              this.$router.push({ path: '/login' })
            }
          })
        }
      }
    )
  })
}
